import { CustomerWithReference } from 'generated-types/skills/customer_references';
import { Panel } from 'rsuite';

import { CustomerReference } from './skills/CustomerReference';

interface CustomerReferencesListProps {
    customersWithoutReference: CustomerWithReference[] | undefined;
    editAllowed: boolean;
}

const CustomersWithoutReferencesList = (props: CustomerReferencesListProps) => {
    const { customersWithoutReference, editAllowed } = props;

    if (customersWithoutReference === undefined) {
        return <div></div>;
    }
    return (
        <>
            {customersWithoutReference.length > 0 && (
                <Panel
                    bordered
                    style={{
                        marginBottom: 20,
                        paddingTop: 20,
                        maxWidth: 1200,
                        width: '100%',
                        background:
                            'linear-gradient(145deg, rgba(31,59,112,1) 0%, rgba(2,175,217,1) 50%, rgba(217,22,92,1) 100%)',
                    }}
                >
                    {(customersWithoutReference as CustomerWithReference[]).map(
                        (customerReference: CustomerWithReference) => (
                            <CustomerReference
                                key={`${customerReference.customer.circles_customer_id}-${customerReference.reference?.reference_uuid}`}
                                editAllowed={editAllowed}
                                customerWithReference={customerReference}
                                reference={customerReference.reference}
                            />
                        ),
                    )}
                </Panel>
            )}
        </>
    );
};

export default CustomersWithoutReferencesList;
